import type { ReactElement } from 'react';

import { useSortBy } from 'react-instantsearch';

import { useAlgoliaSortingOptions } from '../../../utilities/hooks/search/useAlgoliaSortingOptions';

export const VirtualSortBy = (): ReactElement => {
  const { sortingOptions } = useAlgoliaSortingOptions();

  useSortBy({ items: sortingOptions });

  return <></>;
};
